import http from 'lib/http';

// 获取学校课程列表请求配置
export const urlGetSchoolCourseListBySchoolId = '/XOrg/SchoolCourseManager/getSchoolCourseListBySchoolId';
export const urlgetschooCourseListByCourse='/XOrg/SchoolCourseManager/getschooCourseListByCourse';
export const urlAddSchoolCourse = '/XOrg/MajorSchoolCourseManager/addSchoolCourse';
export const urlImportSchoolCourse = '/XOrg/MajorSchoolCourseManager/importSchoolCourse';
export const urlEditSchoolCourse = '/XOrg/MajorSchoolCourseManager/editSchoolCourse';
export const urlDeleteSchoolCourse = '/XOrg/MajorSchoolCourseManager/deleteSchoolCourse';
export const urldeleteByteaId = '/XOrg/SchoolCourseManager/deleteByteaId';
export const urlupdateById = '/XOrg/SchoolCourseManager/updateById';
// wt 2019年1月19日 15:44:28 学校课程关联专业
export const urlgetMajorList = '/XOrg/MajorSchoolCourseManager/getMajorList';
export const urladdMajor = '/XOrg/MajorSchoolCourseManager/addMajor';
export const urlgetSchoolCourseJoinMajorList = '/XOrg/MajorSchoolCourseManager/getSchoolCourseJoinMajorList';
// 专业课程
export const urlGetSchoolCourseListByMajoyId = '/XOrg/MajorSchoolCourseManager/getSchoolCourseListByMajoyId'; 

// 专业课程
export interface GetSchoolCourseListByMajoyId {
    code: string;
    majoyCourseList: {
        id: string;
        DateCreated: string;
        CreateDisplayName: string;
        Title: string;
        SchoolCourseCode: string;
        Description: string;
        MajoyId: string;
        MajoyName: string;
        MajoyType: string;
        MajoyCode: string;
        Cover: string;
    }[];
    msg: string;
    pagination: {
        pageIndex: number;
        pageSize: number;
        totalCount: number;
    };
}

export interface getSchoolCourseListBySchoolId {
    code: string;
    schoolcourseList: {
        id: string;
        DateCreated: string;
        CreateDisplayName: string;
        Title: string;
        SchoolCourseCode: string;
        Description: string;
        Cover: string;
        SchoolCourseId: string;
    }[];
    msg: string;
    pagination: {
        pageIndex: number;
        pageSize: number;
        totalCount: number;
    };
}
export interface msg {
    code: string;
    msg: string;
}

// 获取学校的专业列表
export interface requestMarjorList {
    code: string;
    schoolcourseList: {
        id: string;
        DateCreated: string;
        CreateDisplayName: string;
        MajoyName: string;
        MajoyType: string;
        TeacherDisplayName: string;
        LogoUrl: string;
        Code: string;
    }[];
    msg: string;
    pagination: {
        pageIndex: number;
        pageSize: number;
        totalCount: number;
    };
}
// 获取课程列表
export function getschooCourseListByCourse() {
    return http.post<getSchoolCourseListBySchoolId>(urlgetschooCourseListByCourse, {
    });
   }

// 获取课程列表
export function getSchoolCourseList(SchoolType: number, MajorId: string, page?: number, Code?: string, Title?: string, pageType?: number) {
 return http.post<getSchoolCourseListBySchoolId>(urlGetSchoolCourseListBySchoolId, {
    SchoolType, MajorId, page, Code , Title,  pageType
 });
}
// 获取专业课程列表
export function getSchoolCourseListByMajor(
    SchoolType: number,
    majoyId: string,
    majoyName: string,
    schoolCourseCode?: string,
    title?: string,
    page?: number,
    notset?: string,
    pageSize?: number,
    pageType?: number
) {
    return http.post<GetSchoolCourseListByMajoyId>(urlGetSchoolCourseListByMajoyId, {
        SchoolType, majoyId, majoyName, schoolCourseCode, title, page, notset, pageType, pageSize
    });
}
// 添加学校课程列表
export function addSchoolCourse(MajoyId: string, title: string, schoolcoursecode: string, description: string, cover: string, SchoolType: number,majorIds:string[]) {
    return http.post<msg>(urlAddSchoolCourse, {
        MajoyId,
        title,
        schoolcoursecode,
        description,
        cover,
        SchoolType,
        majorIds
    });
}
// 引入课程
export function importSchoolCourse(majoyId: string , ids: string) {
    debugger;
    return http.post<msg>(urlImportSchoolCourse, {
        majoyId,
        ids
    });
}
// 修改学校课程列表
export function editSchoolCourse(schoolCourseId: string, title: string, code: string, description: string, docJson: string,majorIds:string[],schoolType:number) {
    return http.post<msg>(urlEditSchoolCourse, {
        schoolCourseId, title, code, description, docJson,majorIds,schoolType
    });
}

// 删除学校课程列表
export function deleteSchoolCourse(ids: string[]) {
return http.post<msg>(urlDeleteSchoolCourse, {
    ids
});
}

// 删除学校课程列表
export function deleteByteaId(id: string) {
    return http.post<msg>(urldeleteByteaId, {
        id
    });
}

// 获取学校的专业列表
export function getMajorList() {
    return http.post<requestMarjorList>(urlgetMajorList, {
    });
}


// 学校课程添加专业标签
export function addMajor(majorIds: string[], schoolCourseId: string, schoolType: string) {
    return http.post<msg>(urlupdateById, {
        majorIds,
        schoolCourseId,
        schoolType
    });
}

// 获取学校课程关联的专业列表
export function getSchoolCourseJoinMajorList(schoolCourse: string) {
    return http.post<requestMarjorList>(urlgetSchoolCourseJoinMajorList, {
        schoolCourse
    });
}
